import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {L10nTranslationService} from 'angular-l10n';
import {catchError, map, switchMap} from 'rxjs/operators';

import {debug} from '../../../rxjs-operators';
import {LoadMyClientsFailAction, LoadMyClientsSuccessAction, MyClientsActionTypes} from '../actions/my-clients';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {Client} from '../models/client';
import {SendBackResult} from '../models/send-back-result';
import {ClientsService} from '../services/clients.service';

import {BaseEffect} from './base.effect';

@Injectable()
export class MyClientsEffect extends BaseEffect {
  @Effect()
  load$ = this.actions$.pipe(ofType(MyClientsActionTypes.LOAD),
                             debug('Load my clients action received.'),
                             switchMap(() => this.myClientsService.getMine().pipe(
                                         map((result: SendBackResult<ArrayResponse<Client>>) => new LoadMyClientsSuccessAction(result.data.array)),
                                         catchError((res: Response) => this.catchResponseError(res)))));

  @Effect()
  loadFail$ = this.actions$.pipe(ofType(MyClientsActionTypes.LOAD_FAIL),
                                 debug('A server error occurred while retrieving clients list.'),
                                 map(() => error(this.translation.translate('MY_CLIENTS_LOAD_ERROR'), this.translation.translate('TOAST_ERROR_TITLE'))));

  constructor(private actions$: Actions, private translation: L10nTranslationService, private myClientsService: ClientsService, router: Router) {
    super(router);
  }

  protected handleUnhandledError(response: Response): Action { return new LoadMyClientsFailAction(response.status); }
}
